// extracted by mini-css-extract-plugin
export default {"container":"actions_container__7p301","block":"actions_block__DSVRO"};